import { PropsWithChildren } from "react";
import { cn } from "@/core/helpers/cn";
import { CrossIcon } from "@/shared/icons";
import Button from "@/shared/ui/button/Button";

export function BankBranchDrawer({
  title,
  isOpen,
  onClose,
  size = "md",
  children,
}: PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  size?: "md" | "lg";
}>) {
  const width = size === "md" ? "460px" : "830px";

  return (
    <>
      <div
        tabIndex={0}
        role="button"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onClose();
          }
        }}
        className={cn(
          "absolute z-10 top-0 right-0 h-full w-full bg-dark-900/80 backdrop-blur-sm transition-all duration-300 ease-out opacity-0 pointer-events-none",
          isOpen && "opacity-100 pointer-events-auto",
        )}
        style={{
          willChange: "opacity",
        }}
        onClick={onClose}
      />
      <div
        className={cn(
          `absolute z-10 top-0 right-0 h-full rounded-[1rem] p-7 bg-dark-900 transition-all duration-300 ease-out opacity-0 pointer-events-none`,
          isOpen ? "translate-x-0 opacity-100 pointer-events-auto" : "translate-x-full",
        )}
        style={{
          boxShadow: isOpen ? "0px 0px 200px 0px #21A03899" : "none",
          willChange: "transform, box-shadow",
          transform: isOpen ? "translate3d(0, 0, 0)" : "translate3d(100%, 0, 0)",
          width,
        }}
      >
        <div className="flex flex-col h-full">
          <header className="flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <div className="text-18 font-bold">{title}</div>

              <Button
                color="gray"
                variant="soft"
                className={cn("flex items-center justify-center size-8 p-0 shrink-0")}
                onClick={onClose}
              >
                <CrossIcon className="size-3 text-white" />
              </Button>
            </div>

            <div className="grid grid-cols-[180px_1fr]">
              <div className="border-t border-sbank" />
              <div className="border-t border-dark-800" />
            </div>
          </header>

          <div className="flex flex-col mt-4 h-full">{children}</div>
        </div>
      </div>
    </>
  );
}
